<template>
  <t-layout class="page-container">
    <template v-if="isReady">
      <!-- <t-aside class="menu-wrap">
        <MenuWrap />
      </t-aside> -->
      <t-content class="page-content" id="ent-app">
        <div ref="homeContentInfo" class="home-content__info">
          <div class="nav" v-show="!isQYWX">
            <!-- <MenuBread /> -->
            <!-- <t-breadcrumb :maxItemWidth="'200'">
              <template v-slot:default>
                <t-breadcrumbItem
                  :router="$router"
                  v-for="(item, index) in navigators.filter(
                    item => item.meta && item.meta.name,
                  )"
                  :key="index"
                  :to="{
                    path: item.path
                  }"
                  >{{ item.meta.name }}</t-breadcrumbItem
                >
              </template>
<template v-slot:separator>
                <t-icon name="slash" />
              </template>
</t-breadcrumb> -->
          </div>
          <!-- <div style="height: 54px"></div> -->
          <!-- <home-content /> -->
        </div>
        <router-view :key="routeKey"></router-view>
        <!-- mgb-64 是页面底部有按钮的情况 -->
      </t-content>
    </template>
    <t-loading v-else loading :text="loadingText" fullscreen />
  </t-layout>
</template>
<script>
// import MenuWrap from '@/components/menu.vue';
// import MenuBread from '@/components/menuBread.vue';
// import { $getEntInitInfo } from '@/utils/api';

export default {
  name: 'PageMain',
  components: {
    // MenuWrap,
    // MenuBread
  },
  data() {
    return {
      isReady: true,
      loadingText: "页面加载中...",
      navigators: {},
      isQYWX: false
    }
  },
  computed: {
    routeKey() {
      if (this.$route.path === '/login') return 'login';
      // 标记了 keepOnQueryChange 的页面自己监听 query，改 query 时不重新挂载
      if (this.$route.meta && this.$route.meta.keepOnQueryChange) return this.$route.path;
      return this.$route.fullPath;
    },
  },
  created() {
    console.log("创建", this.$route);

    this.init();
  },
  watch: {
    $route: {
      handler(to, from) {
        console.log("路由变化", to, from);
      },
      immediate: true,
    }
  },
  methods: {
    init() {
      this.loadingText = "页面加载中...";
      this.isReady = true;
    },
  }
}
</script>